import React from 'react';
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import { themeModeAtom, setThemeModeAtom, ThemeMode } from '../../../../atoms/shared/uiAtoms';
import { IOSActionSheet, IOSActionSheetItem } from './IOSActionSheet';
import { trackSettingsEvents } from '../../../../lib/analyticsEnhanced';

interface IOSThemeSelectorProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * iOS 风格的主题选择器组件
 * 使用简化的主题管理系统
 */
export const IOSThemeSelector: React.FC<IOSThemeSelectorProps> = ({
  isOpen,
  onClose
}) => {
  const { t } = useTranslation(['v3/common', 'v3/me']);
  const [themeMode] = useAtom(themeModeAtom);
  const [, setThemeMode] = useAtom(setThemeModeAtom);

  // 选择主题模式
  const handleSelectTheme = (mode: ThemeMode) => {
    const oldTheme = themeMode;

    // 记录主题变更事件
    trackSettingsEvents.themeChanged(oldTheme, mode, {
      trigger: 'theme_selector',
      available_themes: ['light', 'dark', 'system']
    });

    setThemeMode(mode);
    onClose();
  };

  // 主题选项
  const themeItems: IOSActionSheetItem[] = [
    {
      id: 'light',
      label: t('v3/me:appearance.lightMode'),
      isSelected: themeMode === 'light',
      onClick: () => handleSelectTheme('light')
    },
    {
      id: 'dark',
      label: t('v3/me:appearance.darkMode'),
      isSelected: themeMode === 'dark',
      onClick: () => handleSelectTheme('dark')
    },
    {
      id: 'system',
      label: t('v3/me:appearance.systemMode'),
      isSelected: themeMode === 'system',
      onClick: () => handleSelectTheme('system')
    }
  ];

  return (
    <IOSActionSheet
      isOpen={isOpen}
      onClose={onClose}
      items={themeItems}
      title={t('v3/me:appearance.themeMode')}
    />
  );
};

export default IOSThemeSelector;
